import { prettyJson } from "../../../common/CCUtils"
import { log } from "../../../common/Logging"
import { Gender } from "../../../shared/models/Gender"
import {
    MakeFriendAttribute, MakeFriendFifthAttribute, MakeFriendFirstAttribute, MakeFriendFourthAttribute, MakeFriendSecondAttribute, MakeFriendThirdAttribute
} from "./MakeFriendTypes"
import { CharacterFlavor } from "./sprites/MakeFriendCharacter"

export enum MakeFriendStages {
    ARCADE,
    SLEEPOVER,
    POOL
}

export class MakeFriendProgressStore {

    private static innerInstance: MakeFriendProgressStore

    attribute1: MakeFriendFirstAttribute
    attribute2: MakeFriendSecondAttribute
    attribute3: MakeFriendThirdAttribute
    attribute4: MakeFriendFourthAttribute
    attribute5: MakeFriendFifthAttribute
    gender: Gender
    youCharacterFlavor: CharacterFlavor
    friendCharacterFlavor: CharacterFlavor
    completedStages: Array<MakeFriendStages> = []
    lastStageCompleted: MakeFriendStages

    static get instance() {
        return this.innerInstance || (this.innerInstance = new this())
    }

    static destroy() {
        return this.innerInstance = null
    }

    ////////////////
    // Attributes //
    ////////////////

    static get allAttributes(): Array<MakeFriendAttribute> {
        return [
            MakeFriendProgressStore.instance.attribute1,
            MakeFriendProgressStore.instance.attribute2,
            MakeFriendProgressStore.instance.attribute3,
            MakeFriendProgressStore.instance.attribute4,
            MakeFriendProgressStore.instance.attribute5
        ]
    }

    static get allAttributesSet(): boolean {
        return !!MakeFriendProgressStore.instance.attribute1
            && !!MakeFriendProgressStore.instance.attribute2
            && !!MakeFriendProgressStore.instance.attribute3
            && !!MakeFriendProgressStore.instance.attribute4
            && !!MakeFriendProgressStore.instance.attribute5
    }

    setFirstAttribute = (text: MakeFriendFirstAttribute) => {
        this.attribute1 = text
    }

    setSecondAttribute = (text: MakeFriendSecondAttribute) => {
        this.attribute2 = text
    }

    setThirdAttribute = (text: MakeFriendThirdAttribute) => {
        this.attribute3 = text
    }

    setFourthAttribute = (text: MakeFriendFourthAttribute) => {
        this.attribute4 = text
    }

    setFifthAttribute = (text: MakeFriendFifthAttribute) => {
        this.attribute5 = text
    }

    ///////////////
    // Character //
    ///////////////

    setGender = (gender: Gender) => {
        this.gender = gender
    }

    static get getGender(): Gender {
        return MakeFriendProgressStore.instance.gender
    }

    static isBoy(): boolean {
        return MakeFriendProgressStore.instance.gender == Gender.BOY
    }

    static get getFriendName(): string {
        return this.isBoy() ? "Ben" : "Sarah"
    }

    setYouCharacterFlavor = (flavor: CharacterFlavor) => {
        this.youCharacterFlavor = flavor
    }

    setFriendCharacterFlavor = (flavor: CharacterFlavor) => {
        this.friendCharacterFlavor = flavor
    }

    static get getYouCharacterFlavor(): CharacterFlavor {
        return MakeFriendProgressStore.instance.youCharacterFlavor
    }

    static get getFriendCharacterFlavor(): CharacterFlavor {
        return MakeFriendProgressStore.instance.friendCharacterFlavor
    }

    ////////////
    // Stages //
    ////////////

    get arcadeStageCompleted(): boolean {
        return this.completedStages.includes(MakeFriendStages.ARCADE)
    }

    get sleepoverStageCompleted(): boolean {
        return this.completedStages.includes(MakeFriendStages.SLEEPOVER)
    }

    get poolStageCompleted(): boolean {
        return this.completedStages.includes(MakeFriendStages.POOL)
    }

    addStage = (stage: MakeFriendStages) => {
        if (!this.completedStages.includes(stage)) {
            this.completedStages.push(stage)
        }
        this.lastStageCompleted = stage
        log.debug(prettyJson(this.completedStages))
    }
}